"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["Notify"] = 0] = "Notify";
    NotificationType[NotificationType["Feedback"] = 1] = "Feedback";
    NotificationType[NotificationType["BulkSmsUndeliveredNotify"] = 2] = "BulkSmsUndeliveredNotify";
    NotificationType[NotificationType["isAmbassador"] = 3] = "isAmbassador";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
var ReportTypes;
(function (ReportTypes) {
    ReportTypes[ReportTypes["Daily"] = 1] = "Daily";
    ReportTypes[ReportTypes["Weekly"] = 2] = "Weekly";
    ReportTypes[ReportTypes["Monthly"] = 3] = "Monthly";
    ReportTypes[ReportTypes["Quarterly"] = 4] = "Quarterly";
    ReportTypes[ReportTypes["Empty"] = 5] = "Empty";
})(ReportTypes = exports.ReportTypes || (exports.ReportTypes = {}));
var AutoReplyScheduleTypeEnum;
(function (AutoReplyScheduleTypeEnum) {
    AutoReplyScheduleTypeEnum[AutoReplyScheduleTypeEnum["Daily"] = 'DAILY'] = "Daily";
    AutoReplyScheduleTypeEnum[AutoReplyScheduleTypeEnum["Weekly"] = 'WEEKLY'] = "Weekly";
    AutoReplyScheduleTypeEnum[AutoReplyScheduleTypeEnum["Monthly"] = 'MONTHLY'] = "Monthly";
    AutoReplyScheduleTypeEnum[AutoReplyScheduleTypeEnum["Custom"] = 'CUSTOM'] = "Custom";
})(AutoReplyScheduleTypeEnum = exports.AutoReplyScheduleTypeEnum || (exports.AutoReplyScheduleTypeEnum = {}));
var AutoReplyScheduleReplyTypeEnum;
(function (AutoReplyScheduleReplyTypeEnum) {
    AutoReplyScheduleReplyTypeEnum[AutoReplyScheduleReplyTypeEnum["EveryMessage"] = 'EVERY_MESSAGE'] = "EveryMessage";
    AutoReplyScheduleReplyTypeEnum[AutoReplyScheduleReplyTypeEnum["OncePerPeriod"] = 'ONCE_PER_PERIOD'] = "OncePerPeriod";
})(AutoReplyScheduleReplyTypeEnum = exports.AutoReplyScheduleReplyTypeEnum || (exports.AutoReplyScheduleReplyTypeEnum = {}));
class Business {
    static create(data) {
        return Object.assign(new Business(), data);
    }
}
exports.default = Business;


//////////////////
// WEBPACK FOOTER
// ./client/src/models/Business.ts
// module id = 478
// module chunks = 0 1 2